<template>
  <modal
    ref="modal"
    :title="current.title"
    :overlay-click="() => true"
    name="intro"
    class="s-intro-modal"
    @close="onClose">
    <div class="s-intro__content">
      <p>
        {{ current.intro }}
      </p>
    </div>
    <div class="s-intro__cta">
      <ul class="s-intro__steps">
        <li
          v-for="(step, key) in intro._introItems"
          :key="key"
          :class="{'is-active': step.step == current.step}">
          <span/>
        </li>
      </ul>
      <button-simple
        v-if="current !== intro._introItems[0]"
        @click="intro.previousStep()"><small> {{ labels.back }}</small></button-simple>
      <button-base
        v-if="current !== intro._introItems[intro._introItems.length - 1]"
        ref="next"
        @click="intro.nextStep()"><small> {{ labels.next }}</small></button-base>
      <button-base
        v-else
        @click="close"><small>{{ labels.close }}</small></button-base>
    </div>
  </modal>
</template>
<script>
import IntroJs from 'intro.js'
import { setCookie } from '@/lib/cookie'
import Modal from '@/components/UI/Modal/Modal'
import ButtonBase from '@/components/UI/Button/Button'
import ButtonSimple from '@/components/UI/Button/Simple'
export default {
  components: {
    Modal,
    ButtonBase,
    ButtonSimple
  },
  data () {
    return {
      current: {},
      intro: new IntroJs()
    }
  },
  computed: {
    labels () {
      return {
        back: this.$ml.get('back'),
        next: this.$ml.get('next'),
        close: this.$ml.get('close')
      }
    }
  },
  mounted () {
    this.showModal()
  },
  methods: {
    showModal () {
      this.intro.addSteps([
        {
          element: document.querySelector('[data-intro-id="product-selector"]'),
          title: this.$ml.get('step1_title'),
          intro: this.$ml.get('step1_desc')
        },
        {
          element: document.querySelector('[data-intro-id="search"]'),
          title: this.$ml.get('step2_title'),
          intro: this.$ml.get('step2_desc')
        },
        {
          element: document.querySelector('[data-intro-id="filter-selector"]'),
          title: this.$ml.get('step3_title'),
          intro: this.$ml.get('step3_desc')
        }
      ])
      this.intro.setOption('overlayOpacity', '0.6')
      this.intro.setOption('exitOnOverlayClick', false)
      this.intro.start()
      this.current = this.intro._introItems[0]
      this.intro.onchange(this.onChange)
      this.$bus.$emit('modal-show', 'intro')
    },
    onChange () {
      this.current = this.intro._introItems[this.intro._currentStep]
    },
    close () {
      this.$refs.modal.close()
    },
    onClose () {
      this.intro.exit()
      setCookie('intro', true, Infinity, '/')
    }
  }
}
</script>
<style src="./styles/Intro.scss" lang="scss"/>
<style lang="scss" scoped>
@import '~@/components/Panel/styles/_settings.scss';

.s-intro-modal {
  background: transparent;
  z-index: z-index(intro-helper) + 1;

  /deep/ .s-modal__wrapper {
    margin-left: $ui-panel-width + 50px;
    width: 420px;
    max-width: 90%;
  }
}

.s-intro__cta {
  display: flex;
  padding-top: rem(24px);
  border-top: 1px solid color(border, $colors-ui);

  .o-button,
  .o-button-simple {
    margin-left: 10px;
    min-width: 110px;
    text-align: center;
  }

  .o-button {
    &:hover {
      box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.2);
    }
  }
}

.s-intro__steps {
  flex: 1;

  li {
    display: inline-block;
    margin-right: 8px;

    &.is-active {
      span {
        @include themify() {
          background: theme(primary);
        }
      }
    }
  }

  span {
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #DEDFE6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/Intro/Intro.vue